import React from "react";
import { Link } from "react-router-dom";
import {
  Grid,
  Select,
  Container,
  MenuItem,
  InputLabel,
  Button,
  Paper,
  CssBaseline,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TableSortLabel,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddBoxIcon from "@mui/icons-material/AddBox";
import swal from "sweetalert";
import ScrollToTopBtn from "../common/ScrollToTop";
import * as clearingApi from "../../api/clearingApi";
import * as ClearingUtils from "./ClearingUtils";
import { connect } from "react-redux";

class ClearingListAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clearings: [],
      membership: "TFF",
      years: [],
      selectedYear: "",
      year: "",
      newClearing: {},
      page: 0,
      rowsPerPage: 50,
      sortDirection: "desc",
      redirect: false,
      open: false,
    };
  }

  async componentDidMount() {
    try {
      this.setState({ years: ClearingUtils.getYears() });
      await this.fetchClearings();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  fetchClearings = async () => {
    try {
      const { membership, year } = this.state;
      const clearings = await ClearingUtils.getClearings(membership, year);
      if (clearings && clearings.length > 0) {
        clearings.sort(this.compareBy("toDate", "desc"));
        this.setState({ clearings });
      } else {
        this.setState({ clearings: [] });
      }
    } catch (error) {
      console.error("Error fetching clearings:", error);
      this.setState({ clearings: [] });
    }
  };

  onChange = async (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.fetchClearings);
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  handleDelete = async (clearing) => {
    swal({
      title: "Slette avregning?",
      text: "",
      icon: "warning",
      dangerMode: true,
      buttons: ["Avbryt", "OK"],
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await clearingApi.deleteClearing(clearing.clearingId);
          if (response.ok) this.fetchClearings();
          swal("Avregning er slettet!", { icon: "success" });
        } catch (error) {
          console.log(error);
          swal("Error: " + error.message, { icon: "error" });
        }
      }
    });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleDialogChange = (e) => {
    const newClearing = { ...this.state.newClearing };
    newClearing[e.target.name] = e.target.value;
    this.setState({ newClearing });
  };

  handleSave = async () => {
    this.setState({ open: false });
    const { member, year, month } = this.state.newClearing;
    const response = await clearingApi.newClearing(member, year, month);
    if (response) {
      this.fetchClearings();
    }
  };

  compareBy = (key, direction) => {
    return (a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    };
  };

  sortBy = (key) => {
    const { sortDirection, clearings } = this.state;
    const newDirection = sortDirection === "asc" ? "desc" : "asc";
    const sortedArray = [...clearings].sort(this.compareBy(key, newDirection));

    this.setState({
      clearings: sortedArray,
      sortDirection: newDirection,
    });
  };

  render() {
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    return (
      <React.Fragment>
        <Container maxWidth="lg">
          <main style={{ width: "80%", paddingTop: 80, margin: "auto" }}>
            <Paper sx={{ width: "100%", p: 3 }}>
              <CssBaseline />

              <Grid container alignItems="center" spacing={2}>
                <Typography variant="h6">Velg:</Typography>
                <Grid item lg={3}>
                  <FormControl component="fieldset">
                    <RadioGroup row name="membership" value={this.state.membership} onChange={this.onChange}>
                      <FormControlLabel value="TFF" control={<Radio />} label="TFF" />
                      <FormControlLabel value="YFF" control={<Radio />} label="YFF" />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item lg={3}>
                  <FormControl fullWidth>
                    <InputLabel>År</InputLabel>
                    <Select name="year" value={this.state.year || ""} onChange={this.onChange}>
                      <MenuItem value="">Alle</MenuItem>
                      {this.state.years.map((year, index) => (
                        <MenuItem key={index} value={year}>{year}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item>
                  <Button variant="contained" startIcon={<AddBoxIcon />} onClick={this.handleOpen}>
                    Ny Avregning
                  </Button>
                </Grid>
              </Grid>

              {/* Dialog for new clearing */}
              <Dialog fullWidth open={this.state.open} onClose={this.handleClose}>
                <DialogTitle>Ny Avregning</DialogTitle>
                <DialogContent>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Organisasjon</InputLabel>
                    <Select name="member" value={this.state.newClearing.member || ""} onChange={this.handleDialogChange}>
                      <MenuItem value="tff">TFF</MenuItem>
                      <MenuItem value="yff">YFF</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>År</InputLabel>
                    <Select name="year" value={this.state.newClearing.year || ""} onChange={this.handleDialogChange}>
                      {this.state.years.map((year, index) => (
                        <MenuItem key={index} value={year}>{year}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Måned</InputLabel>
                    <Select name="month" value={this.state.newClearing.month || ""} onChange={this.handleDialogChange}>
                      {months &&
                        months.map((month, index) => (
                        <MenuItem key={index} value={month}>{month}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClose}>Avbryt</Button>
                  <Button onClick={this.handleSave}>Lagre</Button>
                </DialogActions>
              </Dialog>

              {/* Table for clearings */}
              <Paper sx={{ width: "100%", mt: 3 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell sx={{ cursor: "pointer" }} onClick={() => this.sortBy("toDate")}>
                        <TableSortLabel active direction={this.state.sortDirection}>År</TableSortLabel>
                      </TableCell>
                      <TableCell sx={{ cursor: "pointer" }} onClick={() => this.sortBy("toDate")}>
                        Måned
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.clearings.length > 0 ? (
                      this.state.clearings
                        .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                        .map((clearing, index) => (
                          <TableRow hover key={index}>
                            <TableCell>
                              <Link to={{ pathname: `/clearingdetailsadmin/${clearing.clearingId}`, state: { clearing, member: this.state.membership } }} style={{ textDecoration: "none" }}>
                                <Button variant="outlined" size="medium" color="primary" sx={{ ml: 2 }}>
                                  <ArrowForwardIosIcon sx={{ mr: 1 }} /> Vis Mer
                                </Button>
                              </Link>
                            </TableCell>
                            <TableCell>{new Date(clearing.toDate).getFullYear()}</TableCell>
                            <TableCell>{new Date(clearing.toDate).getMonth() + 1}</TableCell>
                            <TableCell>
                              <Button sx={{ color: "#B22222" }} onClick={() => this.handleDelete(clearing)}>
                                <DeleteForeverIcon />
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={4} align="center">
                          <Typography>Ingen treff</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>

                {/* Pagination */}
                <TablePagination
                  rowsPerPageOptions={[5, 10, 50]}
                  component="div"
                  count={this.state.clearings.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onPageChange={this.handleChangePage}
                  onRowsPerPageChange={this.handleChangeRowsPerPage}
                />
              </Paper>
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );

  }
}

function mapStateToProps(state) {
  return { signedinuser: state.signedinuserobject?.signedInUser ?? JSON.parse(sessionStorage.getItem("token") || "{}") };
}

export default connect(mapStateToProps)(ClearingListAdmin);
